export default "{\n    \"message\": \"Vous ({{impersonator}}) personnifiez {{impersonated}}\",\n    \"linkCopied\": \"Lien de personnification copié!\"\n}\n"